export const getAddBooksData = (institutionCode) => {
	switch (institutionCode) {
		case 'DUARTE':
			return [...allBooks, ...booksDUARTE];
		case 'MIAMINSTITUTE':
			return [...allBooks, ...data_MIAMINSTITUTE];
		case 'LAURELI':
			return [...allBooks, ...data_LAURELI];
		case 'OMI':
			return [...allBooks, ...data_OMI];
		case 'CMVC':
		case 'AMHEALTH':
		case 'MIAMI_BROWARD':
		case 'HCAS':
		case 'ADTC':
		case 'PCI':
			return [...allBooks, ...DENTISTRY_BOOKS];
		default:
			return allBooks;
	}
};

const allBooks = [
	{
		title: 'Air Source Heat Pump Buying Guide',
		authors: ['Northeast Energy Efficiency Partnerships'],
		abstract:
			'This guide is divided into two main sections. Part 1 describes what a heat pump is, how it works, what types are available, and how to think about choosing one for your home. It also includes general information about heating and cooling costs, and dispels some old myths about heat pumps that don’t apply to today’s high-efficiency models. Once you’ve decided you want to move forward with a heat pump, Part 2 introduces a series of steps to help you organize the process and offers a checklist of questions to ask potential installers. There is more specific guidance on what to look for during the design and installation process, based on the type of system you’re installing and how it fits into your house.',
		publication_date: '2020',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/2.+ASHP_buyingguide_5.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'heat pump',
			'air source heat pump',
			'ASHP',
			'heat pump buying guide',
			'ductless heat pump',
			'mini split',
			'mini-split',
			'split system',
			'heating and cooling',
			'home heating',
			'cooling costs',
			'heating costs',
			'efficiency',
			'high efficiency heat pump',
			'seer',
			'hspf',
			'cop',
			'cold climate heat pump',
			'installer checklist',
			'choose an installer',
			'design and installation',
			'best practices',
			'heat pump myths',
			'retrofit',
			'commissioning',
		],
	},
	{
		title:
			'Assessment of Residential and Small Commercial Air-Source Heat pump (ASHP) Installation Practices in Cold-Climates',
		authors: ['Northeast Energy Efficiency Partnerships'],
		abstract:
			'The following assessment report includes four sections highlighting current practices and guidance: Contractor practices for data collection prior to heat pump selection; Contractor practices for sizing/selecting ASHPs in cold climates; Contractor practices for installing ASHPs in cold climates; and Guidance resources related to sizing, selecting and installing ASHPs in cold climates.',
		publication_date: '2017',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/3.+AssessmentofResandSmallCommASHPInstallationPracticesinCold-Climates.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'heat pump',
			'air source heat pump',
			'ASHP',
			'cold climate',
			'cold-climate heat pump',
			'installation practices',
			'contractor practices',
			'residential',
			'small commercial',
			'heat pump sizing',
			'sizing and selecting',
			'equipment selection',
			'load calculation',
			'manual j',
			'design temperature',
			'commissioning',
			'installation quality',
			'best practice installation',
			'data collection',
			'field assessment',
			'performance verification',
			'airflow',
			'refrigerant charge',
		],
	},
	{
		title: 'Basic HVAC',
		authors: ['Aaron Lee'],
		abstract:
			'Contents: Part I. Electrical Terms and Definitions, Part II. Heating, Part III. Ventilation, Part IV. Mechanical Cooling.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/4.+Lee+-+2021+-+Basic+HVAC.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'basic hvac',
			'hvac fundamentals',
			'heating',
			'ventilation',
			'mechanical cooling',
			'air conditioning',
			'refrigeration cycle',
			'compressor',
			'condenser',
			'evaporator',
			'thermostat',
			'controls',
			'electrical terms',
			'electrical basics',
			'ac power',
			'voltage',
			'current',
			'resistance',
			'hvac terminology',
			'maintenance basics',
			'safety',
			'troubleshooting',
			'ductwork',
			'airflow',
		],
	},
	{
		title: 'Can renewable energy sources power the world?',
		authors: ['The Open University'],
		abstract:
			'We ask the question ‘Can renewable energy sources power the world?’ as a response to the growing awareness that increased use of renewable energy technologies is making a major contribution to global efforts to limit anthropogenic climate change. The course begins by examining the environmental concerns that have caused a rise in interest in renewable energy, introducing the main sources and technologies, and describing global efforts to increase the share of renewables. The course then looks at each of the principal renewable energy technologies and the contributions they might make to global energy demand. Finally, several future energy scenarios are analysed to show how combinations of renewable energy sources and technologies could provide a major share of global energy needs.',
		publication_date: '2018',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/5.+Can+renewable+energy+sources+power+the+world.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'Energy',
			'renewable energy',
			'can renewables power the world',
			'global energy demand',
			'energy transition',
			'decarbonization',
			'climate change',
			'clean energy',
			'solar power',
			'wind power',
			'hydroelectric',
			'geothermal energy',
			'bioenergy',
			'biomass',
			'energy scenarios',
			'future energy',
			'energy mix',
			'grid integration',
			'renewable technologies',
			'carbon emissions',
			'mitigation',
			'sustainability',
		],
	},
	{
		title: 'Climate change and renewable energy',
		authors: ['The Open University'],
		abstract:
			'This free course, Climate Change and Renewable Energy, describes the basic science of the greenhouse effect and how it has been modified by human activities such as the burning of fossil fuels. It describes the large cuts in greenhouse gas emissions that will be required to stabilise the global climate, the role of international climate change negotiations and the need for an energy transition away from fossil fuels to renewable energy sources.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/6.+Climate+change+and+renewable+energy.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'Energy',
			'climate change',
			'renewable energy',
			'greenhouse effect',
			'greenhouse gases',
			'ghg emissions',
			'carbon emissions',
			'fossil fuels',
			'global warming',
			'climate science',
			'mitigation',
			'energy transition',
			'decarbonization',
			'net zero',
			'climate policy',
			'international negotiations',
			'paris agreement',
			'renewables',
			'solar',
			'wind',
			'low carbon energy',
		],
	},
	{
		title: "Electrician's Math and Basic Electrical Formulas",
		authors: ['Mike Holt'],
		abstract:
			'This free PDF is extracted from Mike Holt’s Illustrated Guide to Understanding Electrical Theory. In order to construct a building that will last into the future, a strong foundation is a prerequisite. Math and basic electrical concepts are very similar to the foundation of a building.',
		publication_date: '2023',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/7.+MikeHoltBasicMath.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'Mathematics',
			'Electrical engineering',
			'electrician math',
			'electrical math',
			'electrical formulas',
			'basic electrical theory',
			'ohms law',
			'voltage',
			'current',
			'amperage',
			'resistance',
			'watts',
			'kilowatts',
			'power',
			'power factor',
			'ac circuits',
			'dc circuits',
			'series circuits',
			'parallel circuits',
			'conduit fill',
			'wire sizing',
			'nec calculations',
			'load calculations',
		],
	},
	{
		title: 'Emerging Heat Pump Technologies',
		authors: ['Northeast Energy Efficiency Partnerships'],
		abstract:
			'This brief discusses air source heat pump technologies that are up-and-coming in functionality and availability for applications in the Northeast and Mid-Atlantic region. The emerging heat pump technology categories are listed in Table 1 and provide detailed information about the existing status of the technology as well as advantages, challenges, and technology examples. Under each category, the “applications” section mentions which building type or situation may most readily benefit from that technology.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/8.+Emerging+Heat+Pump+Technologies.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'emerging heat pump technologies',
			'heat pump technology',
			'air source heat pump',
			'ASHP',
			'cold climate heat pump',
			'inverter heat pump',
			'variable speed compressor',
			'variable refrigerant flow',
			'VRF',
			'low gwp refrigerants',
			'refrigerants',
			'R32',
			'R290',
			'heat pump water heater',
			'air-to-water heat pump',
			'packaged terminal heat pump',
			'PTAC',
			'commercial applications',
			'residential applications',
			'building electrification',
			'decarbonization',
			'northeast',
			'mid-atlantic',
		],
	},
	{
		title: 'Energy in buildings',
		authors: ['The Open University'],
		abstract:
			'Themes covered in this free course, Energy in buildings, include reducing heating demand in buildings, heating systems and fuel emissions, and reducing electricity use by appliances.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/9.+Energy+in+buildings.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Energy',
			'energy in buildings',
			'building energy efficiency',
			'heating demand',
			'heat loss',
			'insulation',
			'building envelope',
			'retrofit',
			'weatherization',
			'heating systems',
			'fuel emissions',
			'carbon emissions',
			'decarbonization',
			'electricity use',
			'appliances',
			'energy consumption',
			'energy saving',
			'low energy buildings',
			'building services',
			'energy audit',
		],
	},
	{
		title: 'Engineering: The challenge of temperature',
		authors: ['The Open University'],
		abstract:
			'Temperature: understand the main ways in which a house loses heat energy, carry out basic U-value calculations for windows and insulation materials, understand the factors influencing heating system efficiency, carry out basic calculations concerning the efficiencies and CO2 emissions of different heating systems, carry out basic calculations concerning lighting.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/10.+Engineering+The+challenge+of+temperature.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Refrigeration',
			'temperature',
			'thermal engineering',
			'heat transfer',
			'heat loss',
			'building heat loss',
			'u-value',
			'r-value',
			'windows',
			'insulation materials',
			'thermal insulation',
			'heating efficiency',
			'boiler efficiency',
			'heat pump efficiency',
			'co2 emissions',
			'carbon emissions',
			'lighting efficiency',
			'energy calculations',
			'engineering calculations',
			'home energy',
		],
	},
	{
		title: 'Good practice guide Heat pump installation - March 2022',
		authors: ['Energy Efficiency and Conservation Authority'],
		abstract:
			'This guide provides good practice guidelines for designing and installing the most common type of residential heat pump system – air-to-air single-split heat pump systems (also known as reverse-cycle air conditioners), used primarily for heating. The guide is aimed at experienced installers of heat pumps, and it gives the process to follow for system design and installation into both new and existing homes.',
		publication_date: '2022',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/11.+0468+EEC+Heat+Pump+Install+Guide_DEC2021_3_MM.indd.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Refrigeration',
			'heat pump installation',
			'heat pump installer guide',
			'good practice guide',
			'air-to-air heat pump',
			'single split',
			'split system',
			'reverse cycle air conditioner',
			'design and install',
			'install process',
			'commissioning',
			'airflow setup',
			'refrigerant handling',
			'vacuum pump',
			'leak testing',
			'pipe sizing',
			'indoor unit placement',
			'outdoor unit placement',
			'noise considerations',
			'new homes',
			'existing homes',
		],
	},
	{
		title: 'HVAC/PLUMBING',
		authors: [
			'U.S. Department of Housing and Urban Development Office of Policy Development and Research',
		],
		abstract:
			'The content for this guidebook, HVAC/Plumbing, has been gathered from professionals in the housing rehabilitation field; manufacturers and suppliers of innovative technologies, materials, components, tools, and equipment; trade shows, conferences, reports, and publications considering such issues; trade organizations; and building research centers.',
		publication_date: '1999',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/12.+hvac-Plum.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Plumbing',
			'housing rehabilitation',
			'building rehab',
			'building systems',
			'hvac plumbing guide',
			'mechanical systems',
			'piping',
			'pipe fittings',
			'fixtures',
			'drainage',
			'water supply',
			'domestic hot water',
			'boilers',
			'furnaces',
			'ventilation',
			'air conditioning',
			'tools and equipment',
			'materials and components',
			'codes and standards',
			'trade organizations',
			'construction technology',
		],
	},
	{
		title: 'HVAC Systems Design Handbook',
		authors: ['McGraw-Hill'],
		abstract:
			'A first-hand knowledge of engineering fundamentals is a must for HVAC designers. All problems are helped toward solution by an ability to think clearly, to move from problem definition to identification of alternatives, to evaluation of alternatives, to selection and implementation of preferred action. Knowledge of political constraints (codes and regulations) as well as technical and ethical factors is an important part of the designer’s tool kit. Knowledge of fundamental engineering physics in fluid mechanics, thermodynamics, heat transfer, psychrometrics, and sound control is absolutely essential to the HVAC designer. Energy conservation in system design has become a moral imperative. An understanding of these fundamentals will make all other issues treated in this book easier to understand.',
		publication_date: '2004',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/13.+HVAC4th.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Trades',
			'HVAC',
			'Refrigeration',
			'hvac design',
			'hvac systems design',
			'hvac handbook',
			'engineering fundamentals',
			'fluid mechanics',
			'thermodynamics',
			'heat transfer',
			'psychrometrics',
			'psychrometric chart',
			'duct design',
			'air distribution',
			'load calculations',
			'heating load',
			'cooling load',
			'energy conservation',
			'energy efficiency',
			'codes and regulations',
			'sound control',
			'acoustics',
			'building services engineering',
			'controls',
			'commissioning',
		],
	},
	{
		title: 'Heat Pumps - Operation and Maintenance Guide',
		authors: ['SEAI'],
		abstract:
			'This guide is provided as part of a suite of three heat pump guides: an Implementation Guide, a Technology Guide, and an Operation & Maintenance Guide, which collectively aim at providing an understanding of heat pump technology, its implementation and operational management.',
		publication_date: '2020',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/14.Heat-Pump-Operation-and-Maintenance-Guide.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Trades', 'HVAC', 'Refrigeration'],
	},
	{
		title:
			'5 Myths and Truths about Massage Therapy: Letting Go Without Losing Heart',
		authors: ['Tracy Walton'],
		abstract:
			'This book contains the effects of massage on: Endorphins, Immunity, Cortisol, Blood circulation and “Toxins” and toxin release.',
		publication_date: '2016',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/15.5-Myths-and-Truths-about-Massage-Therapy_final.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Massage', 'Therapy'],
	},
	{
		title: 'Application of Plant-Based Molecules and Materials in Cosmetics',
		authors: ['Paulraj Mosae Mosae Selvakumar'],
		abstract:
			'With the growing demand for products that are gentle on the skin and manufactured by eco-friendly means, the field of cosmetics is witnessing a remarkable shift toward natural ingredients [...]',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/16.cosmetics-11-00211.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Cosmetics', 'Plant Based Products'],
	},
	{
		title: 'BAM Chapter 23: Methods for Cosmetics',
		authors: ['FDA : Human Foods Program'],
		abstract:
			"FDA's Bacteriological Analytical Manual (BAM) presents the agency's preferred laboratory procedures for microbiological analyses of foods and cosmetics.",
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/17.BAM-Ch23-MethodsForCosmetics-070324.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Cosmetics', 'Skincare'],
	},
	{
		title: 'Barbering Techniques for Hairstylists',
		authors: ['Arden Magtiza', 'Gary Franceschini'],
		abstract:
			'This manual serves as a guide for apprentices who desire to grow beyond their foundational haircutting knowledge and skills, and expand their knowledge to include more advanced barbering services, such as beard and moustache design, and straight razor shaves.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/18.Barbering-Techniques-for-Hairstylists-1725562557.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Barbering Techniques', 'Hair'],
	},
	{
		title: 'Cosmetics Labeling Guide',
		authors: ['FDA: Office of the Commissioner'],
		abstract: 'FDA guide to labeling cosmetic products.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/19.Cosmetics-Labeling-Guide.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Cosmetics', 'Skincare'],
	},
	{
		title: 'Evidence-Based Massage Therapy: A Guide for Clinical Practice',
		authors: ['Richard Lebert'],
		abstract:
			'This clinical practice handbook will prove essential to massage therapists, physical therapists, chiropractors, medical doctors, psychologists and other health professionals who care for people with musculoskeletal pain. It is a living document and will be continuously updated as new research becomes available.',
		publication_date: '2018',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/20.Evidence_Based_Massage_Therapy_1592410090_0232c34992.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Massage', 'Therapy'],
	},
	{
		title: 'Hair Colour for Hairstylists: Level 2',
		authors: ['Arden Magtiza'],
		abstract:
			'This manual serves as a guide for apprentices with the desire to stretch beyond their foundational colour knowledge and skills so as to reach a higher level of competency. This text will walk the stylist step-by-step through many current and advanced techniques used in the industry today.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/21.Hair-Colour-for-Hairstylists-Level-2-1666366761.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Hairstyle Techniques', 'Hair'],
	},
	{
		title: 'Introductory Chemistry - 1st Canadian Edition',
		authors: ['Jessie A Key', 'David W. Ball'],
		abstract:
			'The goal of this textbook is not to make you an expert. True expertise in any field is a years-long endeavor. Here I will survey some of the basic topics of chemistry. This survey should give you enough knowledge to appreciate the impact of chemistry in everyday life and, if necessary, prepare you for additional instruction in chemistry.',
		publication_date: '2014',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/22.Introductory-Chemistry-1st-Canadian-Edition-1695676100.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Chemistry', 'Surveys'],
	},
	{
		title:
			'The Case for Pain Relief: 5 Research Studies for Massage Therapists',
		authors: ['Massage Theraphy Foundation'],
		abstract:
			'Contents: ‣ Acupressure and chronic neck pain ‣ Massage therapy and hand pain ‣ Thai massage and pain relief ‣ Massage therapy and low back pain ‣ Myofascial release and fibromyalgia',
		publication_date: '2012',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/23.mtf-pain-relief-ebook.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Beauty and wellness', 'Massage', 'Therapy'],
	},
	{
		title: 'Climate Risk Toolbox',
		authors: ['Food and Agriculture Organization of the United Nations - FAO'],
		abstract:
			'The Climate Risk Toolbox (CRTB) is an open-access resource, hosted on the Hand-in-Hand geospatial platform, a digital public platform that supports users with analyzing and comparing data on climate risks on food and agriculture, to enhance adaptation interventions worldwide (FAO, 2025a, FAO, 2025b).',
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/27.cd4543en.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Biology', 'Climate Risk', 'Climate'],
	},
	{
		title: 'Green Cities Challenge Badge',
		authors: ['Food and Agriculture Organization of the United Nations - FAO'],
		abstract:
			'This booklet is intended as a guide for teachers and youth leaders. These individuals are responsible for the development of programmes and activities that are suitable for their group and for ensuring the required supervision and safety provisions so that all participants are safe and sound.',
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/28.cd6459en.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Biology', 'Climate Risk', 'Climate'],
	},
	{
		title:
			'Infection Prevention and Control in Primary Care: A Toolbox of Resources',
		authors: ['World Health Organization'],
		abstract:
			'The recently published World Health Organization (WHO) Strengthening infection prevention and control in primary care1 document collates existing standards, measurement and implementation approaches, and resources for infection prevention and control (IPC) in primary care. During its development, it became apparent that a number of already existing tools and resources have the potential to support facility-level implementation of IPC in primary care.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/30.9789240035249-eng.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Health Sciences', 'Infections', 'Public Health', 'Toolkit'],
	},
	{
		title: 'Mentorship model for veterinary paraprofessionals',
		authors: ['Food and Agriculture Organization of the United Nations - FAO'],
		abstract:
			'This book contains the experience of the training “Growing your business through preventive livestock health care”. Recruiting and attracting mentors through networking and professional development opportunities was successful and many VPPs had positive experiences and the potential for new long-term professional connections.',
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/31.cd3615en.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Biology', 'Veterinary education', 'Agricultural education'],
	},
	{
		title: 'Business Writing for Everyone',
		authors: ['Arley Cruthers'],
		abstract:
			'Business Writing For Everyone is an inclusive guide to writing in the workplace. The book takes a process-oriented, storytelling approach to composition: focusing less on genre and more on the decisions that effective business communicators make. Business Writing For Everyone also contains interactive H5P activities for students to test their learning, and activities for further reflection that instructors can use in the classroom or assign as homework.',
		publication_date: '2019',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/33.Business-Writing-For-Everyone-1637897846.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Business management', 'Communication skills', 'Writing'],
	},
	{
		title: 'Business/Technical Mathematics',
		authors: ['Izabela Mazur', 'Kim Moshenko'],
		abstract:
			'The content of this textbook is aligned with the British Columbia Adult Basic Education learning outcomes for the Advanced Level Business/Technical Mathematics. The textbook covers nine groups of learning outcomes organized in chapters. The first three chapters cover the core learning outcomes: Operations with Real Numbers; First Degree Equations and Inequalities; Equations and their Graphs. The remaining chapters cover: Systems of Equations; Trigonometry; Health Option; Finance; Data Analysis 1; Data Analysis 2.',
		publication_date: '2021',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/34.BusinessTechnical-Mathematics-1742928169.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Business management', 'Mathematics education'],
	},
	{
		title: 'Communication for Business Professionals',
		authors: ['Ontario Business Faculty', 'eCampusOntario Program Managers'],
		abstract:
			'This book provides a comprehensive, integrated approach to the study and application of written and oral business communication to serve both students and instructors. The text includes features such as learning objectives, exercises, real-world examples, key terms, and post-chapter assessments.',
		publication_date: '2018',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/35.Communication-for-Business-Professionals-1564507599.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Business management', 'Communication skills', 'Writing'],
	},
	{
		title: 'Contemporary Issues in Strategic Marketing',
		authors: ['Ahmet Kemal Sekerkaya'],
		abstract:
			'This book share the valuable ideas of esteemed marketing scholars and experts on the latest and most-valued concepts and developments in different sectors, particularly concerning the competitive marketing landscape in different markets around the world.',
		publication_date: '2020',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/36.7FF3C90DEEA946DC8C87E75B309D73C5.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management', 'Marketing'],
	},
	{
		title: 'Digital Accessibility as a Business Practice',
		authors: ['Digital Education Strategies', 'The Chang School'],
		abstract:
			'Most business leaders would agree that reaching the broadest audience is good for a business’s bottom line. A good portion of that audience will be people with disabilities. This book answers how an organization can ensure it is as accessible as it can be to clients and customers, and provides strategies and resources to make digital accessibility a part of an organization’s business culture.',
		publication_date: '2019',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/37.Digital-Accessibility-as-a-Business-Practice-1571157632.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},
	{
		title: 'Electronic Commerce: The Strategic Perspective',
		authors: [
			'Richard T. Watson',
			'Pierre Berthon',
			'Leyland F. Pitt',
			'George M. Zinkhan',
		],
		abstract:
			'This book is written both for practitioners and business students. Managers wishing to understand how electronic commerce is revolutionizing business will find comprehensive coverage of essential business issues (e.g., pricing and distribution). Advanced business students will find the blend of academic structure and practical examples engaging.',
		publication_date: '2014',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/38.Electronic-Commerce-The-Strategic-Perspective-1653439969.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Economics',
			'Finance',
			'Business Management',
			'Electronic commerce',
		],
	},
	{
		title: 'Estado abierto y gestión pública: el papel del sector académico',
		authors: ['Comisión Económica para América Latina y el Caribe - CEPAL'],
		abstract:
			'En este libro se aborda el papel del sector académico en relación con el paradigma de Estado abierto inclusivo y su gestión pública, en el marco de la Agenda 2030 para el Desarrollo Sostenible, la apertura, la innovación, las nuevas formas de participación y colaboración del sector y sus proyecciones en el marco de la denominada “era exponencial”, en que los cambios en el tiempo se producen con una creciente aceleración.',
		publication_date: '2023',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/39.S2300544_es.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management', 'Public finance'],
	},
	{
		title:
			'Global Corruption: Its Regulation under International Conventions, US, UK, and Canadian Law and Practice - 4th Edition',
		authors: ['Gerry Ferguson'],
		abstract:
			'This book was created to make it easier for professors to offer a law school course on global corruption and serves as a resource tool for anti-corruption work. It covers the nature and extent of corruption and sets out international standards and requirements to combat corruption, including the UN Convention Against Corruption (UNCAC) and the OECD Bribery of Foreign Officials Convention (OECD Convention).',
		publication_date: '2022',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/40.OTB_187_02_Global_Corruption_4th_Edition_d5ab40cb1b.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Business management', 'Corruption'],
	},

	{
		title: 'Human Security in World Affairs: Problems and Opportunities',
		authors: ['Alexander Lautensach'],
		abstract:
			'This first and only university textbook of human security is intended as an introductory text from senior undergraduate level up and includes chapters by 24 authors, from BC, Canada, and around the globe, that encompass the full spectrum of disciplines contributing to the human security field. It is based on the four pillar model of socio-political security, economic security, environmental security and health security.',
		publication_date: '2020',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/42.Human-Security-in-World-Affairs-Problems-and-Opportunities-2nd-edition-1660156721.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},

	{
		title: 'Jobs and Prosperity',
		authors: ['World Bank'],
		abstract:
			'Economic growth in Europe and Central Asia eased to 2.4 percent in 2025, reflecting a sharp slowdown in the Russian Federation. Outside Russia, growth momentum remains broadly resilient, supported by private consumption, infrastructure spending, and a gradual recovery in trade. While a modest pickup is expected in 2026–27, growth is likely to remain well below the 2000–19 average. In this slow-growth environment, downside risks dominate, with the potential for setbacks in reforms posing a significant threat to investor confidence, private sector dynamism, and job creation.',
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/43.Jobs+and+Prosperity-Fall+2025+ECA+Economic+Update.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},

	{
		title:
			'Latin American economic growth in the late twentieth century: evidence and interpretation',
		authors: ['Andrés Solimano', 'Raimundo Soto'],
		abstract:
			'This report examines how job platforms can create better work opportunities for women and other underrepresented groups. It focuses on the main barriers they face, how platforms operate, and practical steps to make platforms more inclusive. The findings draw on interviews with platform leaders and researchers, academic studies, and real-world examples, highlighting concrete strategies to improve women’s engagement and success on platforms. Based on this evidence, the report outlines nine recommendations for platforms to better engage women and marginalized jobseekers and expand their access to work opportunities.',
		publication_date: '2003',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/44Jobs+and+Prosperity-Fall+2025+ECA+Economic+Update.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},

	{
		title: 'Leading Innovation',
		authors: ['Kerri Shields'],
		abstract:
			'Innovation today considers the economic, environmental, and/or social sustainability of an innovative initiative from its inception or idea generation through to its commercialization or implementation. This concept applies to many types of innovation, such as products, processes, services, technologies, and business models. Companies use innovation as a means to gain a competitive advantage and bring value to business stakeholders. This book introduces business innovation, from incremental innovation, such as enhancing the performance of an existing product, service, or process, to radical or disruptive innovation, such as one that has a significant impact on a market. The content examines how leaders foster a culture of innovation, how companies turn creativity into innovation, and how innovation transforms not only organizations, but economies as well. The second edition of this book has two new chapters, as well as new and reorganized content, new exercises, an updated test bank and lecture slides, and modifications to meet WCAG 2.0 accessibility standards.',
		publication_date: '2023',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/45.Leading-Innovation-2nd-Edition-1758986250.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},

	{
		title: 'Macroeconomics: Theory through Applications',
		authors: ['Russell Cooper', 'A. Andrew John'],
		abstract:
			'The intended audience of the textbook is first-year undergraduates taking courses on the principles of macroeconomics and microeconomics. Many may never take another economics course. We aim to increase their economic literacy both by developing their aptitude for economic thinking and by presenting key insights about economics that every educated individual should know.',
		publication_date: '2012',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/46.Macroeconomics_Theory_through_Application_Attributed_71be28b4f9.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},

	{
		title:
			'Making Job Platforms Work for Women: A Guide for Practitioners and Researchers',
		authors: ['World Bank'],
		abstract:
			'This report examines how job platforms can create better work opportunities for women and other underrepresented groups. It focuses on the main barriers they face, how platforms operate, and practical steps to make platforms more inclusive. The findings draw on interviews with platform leaders and researchers, academic studies, and real-world examples, highlighting concrete strategies to improve women’s engagement and success on platforms.',
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/47.DU-b8ca55b8-8b40-402c-98a2-afa98e1042e3.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management', 'Women'],
	},

	{
		title:
			'Market Segmentation Analysis: Understanding It, Doing It, and Making It Useful',
		authors: ['Friedrich Leisch', 'Sara Dolnicar', 'Bettina Grün'],
		abstract:
			'This open access book offers something for everyone working with market segmentation: practical guidance for users of market segmentation solutions; organisational guidance on implementation issues; guidance for market researchers in charge of collecting suitable data; and guidance for data analysts with respect to the technical and statistical aspects of market segmentation analysis.',
		publication_date: '2018',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/48.PUB_580_Leisch_Market_Segmentation_Analyses.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management', 'Marketing'],
	},

	{
		title:
			'Measuring the Internet economy in Latin America: the cases of Brazil, Chile, Colombia and Mexico',
		authors: ['Veronika Vilgis', 'Valeria Jordán', 'Alejandro Patiño'],
		abstract:
			'The adoption of digital technologies is a crucial tool for bridging the productivity gaps between countries in Latin America and the Caribbean and more developed nations, generating new sources of growth, and creating high-quality jobs. Evidence-based policies are needed to harness the potential of these technologies, guide technological change, seize opportunities and mitigate risks. This publication presents an exploratory study conducted in Brazil, Chile, Colombia and Mexico, in which various sources of information are combined, including web data and official statistics, to measure the online activity of businesses.',
		publication_date: '2024',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/49.S2300976_en.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},

	{
		title:
			'OECD Science, Technology and Innovation Outlook 2025: Policy Insights to Navigate Today’s Shifting Landscape',
		authors: ['OECD'],
		abstract:
			'The OECD Science, Technology and Innovation Outlook 2025 reviews key trends in science, technology and innovation (STI) policy in OECD countries and major partner economies. This edition comes at a time of accelerating technological change, intensifying geopolitical tensions and urgent demands for transformative responses to economic and societal challenges.',
		publication_date: '2025',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/50.5fe57b90-en.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},

	{
		title: 'Principles of Economics',
		authors: ['Steven A. Greenlaw', 'David Shapiro', 'Daniel MacDonald'],
		abstract:
			'Principles of Economics 3e covers the scope and sequence of most introductory economics courses. The third edition takes a balanced approach to the theory and application of economics concepts. The text uses conversational language and ample illustrations to explore economic theories and provides a wide array of examples using both fictional and real-world scenarios.',
		publication_date: '2022',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/51.Economics3e-WEB_AObkTqf.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},

	{
		title: 'Principles of Microeconomics',
		authors: ['Libby Rittenberg', 'Tim Tregarthen'],
		abstract:
			'Recognizing that a course in economics may seem daunting to some students, we have tried to make the writing clear and engaging. Clarity comes in part from the intuitive presentation style, but we have also integrated a number of pedagogical features that we believe make learning economic concepts and principles easier and more fun. These features are very student-focused. The chapters themselves are written using a modular format. In particular, chapters generally consist of three main content sections that break down a particular topic into manageable parts. Each content section contains not only an exposition of the material at hand but also learning objectives, summaries, examples, and problems. Each chapter is introduced with a story to motivate the material and each chapter ends with a wrap-up and additional problems. Our goal is to encourage active learning by including many examples and many problems of different types.',
		publication_date: '2012',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/52.Principles_of_Microeconomics_Attributed_1c1a2d5158.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Economics', 'Finance', 'Business Management'],
	},

	{
		title: 'Professional Communications OER: Module 1: Foundations',
		authors: [
			'Olds College OER Development Team',
			'JR Dingwall',
			'Chuck Labrie',
			'TK McLennon',
			'Laura Underwood',
		],
		abstract:
			'This module serves as an introduction to communication in a professional context. In a world where change is constant and technology proliferates, the foundational skills developed here will enable students to balance the needs of their audience with their communication goals. Students will develop the skills for selecting the appropriate medium for their message and measuring their results; they will be prepared for high performance in today’s ever-changing workplace.',
		publication_date: '2015',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/53.e_Textbook_Part1_Foundations_PDF_2f50c3fb74.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Communication administration',
			'Business Management',
			'Communication strategies',
		],
	},

	{
		title: 'Professional Communications OER: Module 2: Writing',
		authors: [
			'Olds College OER Development Team',
			'JR Dingwall',
			'Chuck Labrie',
			'TK McLennon',
			'Laura Underwood',
		],
		abstract:
			'This is module 2 of 4, in which students learn to communicate in writing. Topics include grammar and punctuation, writing workplace documents, revising workplace documents, ethical guidelines for writing, and information literacy.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/54.e_Textbook_Part_2_Writing_978c9cdcc7.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Communication administration',
			'Business Management',
			'Communication strategies',
		],
	},

	{
		title: 'Professional Communications OER: Module 3: Presentations',
		authors: [
			'Olds College OER Development Team',
			'JR Dingwall',
			'Chuck Labrie',
			'TK McLennon',
			'Laura Underwood',
		],
		abstract:
			'This is module 3 of 4, in which students will learn the art and science of putting together an impressive presentation. Topics include presentation styles, developing a presentation strategy, presentation aids, and communicating with a live audience.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/55.e_Textbook_Part_3_Presentations_8b2dcf614d.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Communication administration',
			'Business Management',
			'Communication strategies',
		],
	},

	{
		title: 'Professional Communications OER: Module 4: Interpersonal',
		authors: [
			'Olds College OER Development Team',
			'JR Dingwall',
			'Chuck Labrie',
			'TK McLennon',
			'Laura Underwood',
		],
		abstract:
			'This is module 4 of 4, in which students will learn how people communicate with and respond to each other. Topics include communication and diversity, interpersonal communication preferences, cross-cultural communication, and conflict resolution.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/56.e_Textbook_Part_4_Interpersonal_Communication_78209e7eb5.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Communication administration',
			'Business Management',
			'Communication strategies',
		],
	},

	{
		title: 'Promotion and Marketing Communications',
		authors: ['Umut Ayman', 'Anil', 'Kemal Kaya'],
		abstract:
			'This edited Promotion and Marketing Communications book is an original volume that presents a collection of chapters authored by various researchers and edited by marketing communication professionals. To survive in the competitive world, companies feel an urge to achieve a competitive advantage by applying accurate marketing communication tactics. Understanding marketing communication is an essential aspect for any field and any country. Hence, in this volume there is the latest research about marketing communication under which marketing strategies are delicately discussed. This book does not only contribute to the marketing and marketing communication intellectuals but also serves different sector company managerial positions and provides a guideline for people who want to attain a career in this field, giving them a chance to acquire the knowledge regarding consumer behavior, public relations, and digital marketing themes.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/57.authors_book.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: ['Marketing', 'Business Management', 'Communication strategies'],
	},

	{
		title: 'Writing for Strategic Communication Industries',
		authors: ['Jasmine Roberts'],
		abstract:
			'Good writing skills are important in today’s competitive work environment. This is especially the case for communication-related professions such as public relations, brand communication, journalism, and marketing. Writing for Strategic Communication Industries emphasizes practical application of academic inquiry to help readers improve their writing skills. This book has straightforward chapters that use real-world examples to illustrate key points. It discusses different writing styles and techniques and provides examples of communication materials such as press releases, creative briefs, feature articles, and more. It includes embedded videos of insights from communication professionals, tips on pitching to the media, and a collection of popular sources for further explanation.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/58.Writing-for-Strategic-Communication-Industries-1754428380.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Communication administration',
			'Business Management',
			'Communication strategies',
		],
	},

	{
		title: 'Manual programación neurolingüística aplicada a la empresa',
		authors: ['Paloma Gómez Alonso'],
		abstract:
			'Este manual aborda la aplicación de la programación neurolingüística (PNL) en el entorno empresarial, proporcionando herramientas prácticas para mejorar la comunicación, el liderazgo, la negociación y el desarrollo personal dentro de las organizaciones. A través de ejemplos aplicados, el libro explica cómo comprender mejor el comportamiento humano, optimizar relaciones laborales y potenciar habilidades profesionales clave en contextos corporativos.',
		publication_date: '2013',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/manual-programacion-neurolingui-gomez-alonso-paloma_compress.pdf',
		type: 'BOOK',
		resource_origin: 'Biblioteca Areandina',
		peer_reviewed: false,
		words: [
			'Manual programación neurolingüística aplicada a la empresa',
			'Programación neurolingüística',
			'PNL aplicada',
			'Comunicación empresarial',
			'Desarrollo personal',
			'Liderazgo',
			'Gestión empresarial',
			'Habilidades blandas',
		],
	},
];

const data_MIAMINSTITUTE = [
	{
		title: 'A challenge for the author',
		authors: ['Uta Hagen'],
		abstract:
			'A Challenge for the Actor” by Uta Hagen is a fundamental work for actors looking to deepen their craft. Through her personal experiences and teachings, Hagen provides a practical and profound approach to the acting process. The book emphasizes the importance of self-awareness, emotional connection, and total commitment to the character. With a clear focus on authenticity and emotional truth, Hagen challenges actors to push beyond conventional techniques, striving for a more complete and resonant performance',
		publication_date: '1991',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/A_Challenge_for_the_actor.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'challenge',
			'author',
			'acting',
			'act',
			'actor',
			'uta',
			'hagen',
			'performance',
			'authenticity',
			'emotional truth',
			'self-awareness',
			'character',
			'acting techniques',
			'art of acting',
			'performance challenge',
			'commitment',
			"actor's craft",
			'theatre',
			'method acting',
		],
	},
	{
		title: 'A Dream of Passion',
		authors: ['Lee Strasberg'],
		abstract:
			"In this foundational text, Lee Strasberg—the legendary father of Method Acting—details the development and principles of his revolutionary technique. He traces its roots from the Stanislavski System and provides essential exercises for the actor's training.",
		publication_date: '1987',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/A_Dream_of_Passion.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'dream',
			'passion',
			'acting',
			'actor',
			'lee',
			'strasberg',
			'method',
			'acting',
			'stanislavski',
			'performance',
			'emotional preparation',
			'psychological realism',
			'authenticity',
			'character development',
			'acting techniques',
			'theatre',
			'training',
			'stage',
			'art',
		],
	},
	{
		title: 'The Power of the Actor',
		authors: ['Ivana Chubbuck'],
		abstract:
			'A groundbreaking step-by-step guide to the Chubbuck Technique, a revolutionary approach to acting that teaches performers how to use their personal experiences and emotions to create powerful, authentic characters. This method combines psychological motivation with practical acting tools to achieve compelling performances.',
		publication_date: '2004',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Power_of_the_Actor_Revised_and_Updated.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'power',
			'acting',
			'actor',
			'act',
			'ivana',
			'chubbuck',
			'chubbuck Technique',
			'character',
			'emotional preparation',
			'psychological realism',
			'script analysis',
			'performance',
			'scene work',
			'hollywood',
			'theatre',
			'audition',
			'personalization',
			'objective',
			'obstacle',
		],
	},
	{
		title: "The Filmmaker's Eye",
		authors: ['Gustavo Mercado'],
		abstract:
			'A comprehensive guide to the language of cinema, this book explores the fundamental principles of shot composition, lighting, and camera techniques. It provides filmmakers with essential tools to create visually compelling and emotionally resonant storytelling through masterful use of cinematic language and visual design.',
		publication_date: '2019',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Filmmakers_Eye.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'filmmakers',
			'eye',
			'gustavo',
			'mercado',
			'filmmaking',
			'cinematography',
			'shot composition',
			'camera techniques',
			'visual storytelling',
			'lighting',
			'film direction',
			'cinematic language',
			'frame composition',
			'visual design',
			'film production',
			'camera angles',
			'lens selection',
			'movement',
			'color theory',
			'visual narrative',
			'film aesthetics',
			'directing',
		],
	},
	{
		title: 'The Color Correction Handbook',
		authors: ['Alexis Van Hurkman'],
		abstract:
			'A comprehensive professional guide to color grading and correction techniques for film, video, and digital media. This handbook covers fundamental principles, advanced workflows, and practical techniques for achieving cinematic looks, managing consistency across shots, and mastering the art of color storytelling.',
		publication_date: '2014',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Color_Correction_Handbook.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'color',
			'correction',
			'handbook',
			'alexis',
			'van',
			'hurkman',
			'color grading',
			'color correction',
			'color theory',
			'color timing',
			'davinci resolve',
			'color science',
			'cinematic looks',
			'color workflow',
			'video editing',
			'post production',
			'color matching',
			'primary correction',
			'secondary correction',
			'scopes',
			'waveform',
			'vectorscope',
			'color management',
			'LUTs',
			'lookup tables',
		],
	},
	{
		title: 'The Complete Guide to Film and Digital Production',
		authors: ['Lorene Wales'],
		abstract:
			'A comprehensive guide to the entire filmmaking process, covering all aspects of production from development and pre-production through post-production and distribution. This resource details the roles of crew members, production workflows, budgeting, and the integration of digital technologies in modern filmmaking.',
		publication_date: '2017',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_complete_Guide_to_digital_film_production.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'complete',
			'guide',
			'film',
			'digital',
			'production',
			'lorene',
			'wales',
			'filmmaking',
			'film production',
			'digital production',
			'pre-production',
			'post-production',
			'film budgeting',
			'production workflow',
			'film crew',
			'production roles',
			'film distribution',
			'production management',
			'film industry',
			'production process',
			'digital workflow',
			'film development',
			'production logistics',
		],
	},
	{
		title: 'Respect for Acting',
		authors: ['Uta Hagen'],
		abstract:
			"A foundational text in actor training that presents a practical approach to the craft of acting. The book outlines essential techniques for developing believable characters, including exercises for emotional recall, physical action, and moment-to-moment truth on stage. It emphasizes the actor's dedication to authenticity and psychological realism in performance.",
		publication_date: '1973',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Respect_for_acting.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'respect',
			'acting',
			'uta',
			'hagen',
			'acting',
			'actor training',
			'character development',
			'emotional recall',
			'physical action',
			'stagecraft',
			'theatre',
			'acting techniques',
			'psychological realism',
			'authenticity',
			'moment-to-moment',
			'acting exercises',
			'performance',
			'acting theory',
			'drama',
			'theater',
			'actor preparation',
			'scene work',
			'object exercises',
		],
	},
	{
		title: 'An Actor Prepares',
		authors: ['Konstantin Stanislavski'],
		abstract:
			"The foundational text of modern acting theory, this book presents Stanislavski's revolutionary system through the narrative of a young actor's training. It introduces core concepts such as emotional memory, the magic if, given circumstances, and objectives that transformed acting into a psychological and disciplined art form.",
		publication_date: '1936',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/An+Actor+Prepares.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'actor',
			'prepares',
			'konstantin',
			'stanislavski',
			'acting',
			'act',
			'method acting',
			'emotional memory',
			'the magic if',
			'given circumstances',
			'objectives',
			'super objective',
			'through line',
			'psychological realism',
			'actor training',
			'theatre',
			'drama',
			'character development',
			'stagecraft',
			'performance technique',
			'internal acting',
			'emotional recall',
			'concentration',
			'imagination',
		],
	},
	{
		title: 'Building a Character',
		authors: ['Konstantin Stanislavski'],
		abstract:
			"The second book in Stanislavski's seminal acting trilogy, focusing on the external aspects of character creation. This work explores physical transformation, voice, speech, movement, and the development of a character's external traits while maintaining psychological truth. It provides practical exercises for actors to master the physical embodiment of their roles.",
		publication_date: '1950',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Building-A-Character.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'building',
			'character',
			'konstantin',
			'stanislavski',
			'acting',
			'character development',
			'physical transformation',
			'voice training',
			'speech',
			'movement',
			'external technique',
			'characterization',
			'body language',
			'physical acting',
			'stage presence',
			'actor training',
			'stanislavski system',
			'theatre',
			'drama',
			'performance',
			'embodiment',
			'gesture',
			'posture',
			'vocal projection',
			'physical expression',
		],
	},
	{
		title: 'Creating a Role',
		authors: ['Konstantin Stanislavski'],
		abstract:
			"The third volume in Stanislavski's groundbreaking trilogy, this book focuses on the practical application of his system to specific roles and plays. It guides actors through the complete process of role development, from initial script analysis and research to rehearsal techniques and final performance, using detailed examples from classic plays.",
		publication_date: '1961',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Creating+a+role.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'creating',
			'role',
			'konstantin',
			'stanislavski',
			'acting',
			'script analysis',
			'character development',
			'rehearsal techniques',
			'role preparation',
			'stanislavski system',
			'play analysis',
			'actor preparation',
			'theatre',
			'drama',
			'performance',
			'character research',
			'subtext',
			'given circumstances',
			'objectives',
			'super objective',
			'emotional preparation',
			'scene work',
			'acting process',
			'theatrical interpretation',
		],
	},
	{
		title: 'Audition',
		authors: ['Michael Shurtleff'],
		abstract:
			'The definitive guide to auditioning for actors, presenting the famous 12 guideposts for script analysis and performance. This book teaches actors how to make strong choices, build relationships on stage, and stand out in auditions through practical techniques for scene analysis, character development, and emotional connection.',
		publication_date: '1978',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/audition-by-michael-shurtleff.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'audition',
			'michael',
			'shurtleff',
			'acting',
			'auditioning',
			'12 guideposts',
			'script analysis',
			'casting',
			'actor',
			'audition techniques',
			'scene study',
			'character choices',
			'relationship',
			'conflict',
			'humor',
			'opposites',
			'discoveries',
			'communication',
			'competition',
			'importance',
			'theatre',
			'film',
			'television',
			'casting director',
			'performance',
		],
	},
	{
		title: 'The Science and Art of Acting for the Camera',
		authors: ['John Howard Swain'],
		abstract:
			'A comprehensive guide that bridges the gap between stage acting and camera performance, exploring both the artistic and technical aspects of acting for film and television. The book provides practical techniques for adapting acting skills to the camera, covering emotional truth, technical requirements, and the specific demands of on-camera work.',
		publication_date: '2017',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_Science_and_Art_of_Acting_for_the_Camera.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'science',
			'art',
			'acting',
			'camera',
			'john',
			'howard',
			'swain',
			'acting',
			'camera acting',
			'film acting',
			'television acting',
			'on-camera technique',
			'emotional truth',
			'technical acting',
			'screen performance',
			'film set',
			'camera awareness',
			'subtlety',
			'continuity',
			'frame',
			'lens',
			'close-up',
			'film production',
			'audition techniques',
			'character development',
		],
	},
	{
		title: 'Cinematography: Theory and Practice',
		authors: ['Blain Brown'],
		abstract:
			'A comprehensive guide to both the artistic and technical aspects of cinematography, covering everything from fundamental camera operations to advanced lighting techniques and visual storytelling. This book explores how cinematographers use lighting, composition, camera movement, and color to create mood, meaning, and narrative impact in film and video.',
		publication_date: '2016',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Cinematography_theory_and_practice.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'cinematography',
			'theory',
			'practice',
			'blain',
			'brown',
			'cinematography',
			'lighting',
			'camera',
			'composition',
			'visual storytelling',
			'film production',
			'camera movement',
			'color theory',
			'exposure',
			'lenses',
			'camera angles',
			'shot composition',
			'digital cinema',
			'film techniques',
			'visual design',
			'depth of field',
			'framing',
			'camera operators',
			'director of photography',
			'DP',
			'film lighting',
			'image making',
		],
	},
	{
		title: 'Film Directing Shot by Shot',
		authors: ['Steven D. Katz'],
		abstract:
			'A visual guide to filmmaking that explores the language of cinema through storyboards, shot composition, and visual storytelling techniques. This book provides practical tools for directors to plan and visualize their films, covering continuity, camera angles, blocking, and the relationship between visual design and narrative structure.',
		publication_date: '1991',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Film_Directing_Shot_by_Shot.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'film',
			'directing',
			'shot',
			'shot',
			'steven',
			'katz',
			'film directing',
			'shot composition',
			'storyboarding',
			'visual storytelling',
			'camera angles',
			'continuity',
			'blocking',
			'scene planning',
			'visual design',
			'film language',
			'directing techniques',
			'pre-production',
			'storyboard',
			'frame',
			'cinematic space',
			'camera movement',
			'visual narrative',
			'film planning',
			'director',
			'shot list',
		],
	},
	{
		title: 'In the Blink of an Eye',
		authors: ['Walter Murch'],
		abstract:
			'A seminal work on film editing that explores the philosophical, psychological, and practical aspects of editing. Walter Murch presents his revolutionary ideas about how editing relates to human perception, including his famous "Rule of Six" and insights on why cuts work, blink timing, and the emotional rhythm of film.',
		publication_date: '1995',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/In_the_Blink_of_an_Eye.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'blink',
			'eye',
			'walter',
			'murch',
			'film editing',
			'editing',
			'film theory',
			'editing techniques',
			'rule of six',
			'film rhythm',
			'emotional rhythm',
			'continuity editing',
			'film perception',
			'editing philosophy',
			'film psychology',
			'cutting',
			'transition',
			'timing',
			'blink',
			'film structure',
			'narrative flow',
			'post-production',
			'film making',
			'editor',
		],
	},
	{
		title: 'Grammar of the Film Language',
		authors: ['Daniel Arijon'],
		abstract:
			'A comprehensive visual guide to the fundamental principles of film language and visual storytelling. This classic work systematically explores shot composition, camera angles, editing techniques, and visual continuity, serving as an essential reference for filmmakers seeking to master the visual vocabulary of cinema.',
		publication_date: '1976',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Grammar_of_the_film_language.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'grammar',
			'film',
			'language',
			'daniel',
			'arijon',
			'film language',
			'visual storytelling',
			'shot composition',
			'camera angles',
			'editing',
			'continuity',
			'visual grammar',
			'film techniques',
			'cinematic syntax',
			'framing',
			'camera movement',
			'scene transition',
			'visual narrative',
			'film direction',
			'cinematography',
			'storytelling',
			'film syntax',
			'visual continuity',
			'film making',
			'directing',
		],
	},
	{
		title: 'Directing the Documentary',
		authors: ['Michael Rabiger'],
		abstract:
			'A comprehensive guide to the art and craft of documentary filmmaking, covering all stages from concept development to distribution. This book provides practical techniques for research, interviewing, shooting in real-world conditions, ethical considerations, and shaping raw footage into compelling narrative stories that reflect truth and perspective.',
		publication_date: '2015',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Directing-the-Documentary.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'directing',
			'documentary',
			'michael',
			'rabiger',
			'documentary',
			'filmmaking',
			'documentary directing',
			'non-fiction',
			'interview techniques',
			'ethical filmmaking',
			'documentary research',
			'real-world shooting',
			'story structure',
			'documentary editing',
			'cinema verite',
			'observational cinema',
			'documentary ethics',
			'fundraising',
			'distribution',
			'post-production',
			'character development',
			'truth in storytelling',
			'documentary narrative',
			'film proposal',
		],
	},
	{
		title: "The Filmmaker's Handbook",
		authors: ['Steven Ascher', 'Edward Pincus'],
		abstract:
			'A comprehensive guide to the entire filmmaking process, from development and pre-production to distribution. This authoritative volume covers techniques for dramatic, documentary, corporate, and experimental projects, providing practical advice on shooting, lighting, sound recording, editing, and the business aspects of producing and funding a film.',
		publication_date: '2013',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The-Filmmakers-Handbook.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'filmmakers',
			'handbook',
			'steven',
			'ascher',
			'edward',
			'pincus',
			'filmmaking',
			'film production',
			'digital video',
			'cinematography',
			'lighting',
			'sound recording',
			'video editing',
			'post-production',
			'film distribution',
			'pre-production',
			'documentary',
			'DSLR',
			'film budgeting',
			'film directing',
		],
	},
	{
		title: 'Film Production Management',
		authors: ['Bastian Clevé'],
		abstract:
			'A comprehensive guide to film production management focusing on the entire production process from development to delivery. This third edition covers contemporary practices in budgeting, scheduling, legal requirements, and international co-productions, providing essential knowledge for producers and production managers in the global film industry.',
		publication_date: '2006',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Film_Production_Management.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'film',
			'production',
			'management',
			'bastian',
			'clevé',
			'production management',
			'film budgeting',
			'production scheduling',
			'international co-productions',
			'film financing',
			'production law',
			'contracts',
			'rights clearance',
			'film insurance',
			'production planning',
			'shoot management',
			'post-production supervision',
			'film delivery',
			'producer',
			'line producer',
			'film industry',
			'global production',
		],
	},
	{
		title: 'Acting in Film',
		authors: ['Michael Caine'],
		abstract:
			'An essential guide to film acting by acclaimed actor Michael Caine, offering practical advice and techniques for performing in front of the camera. The book covers everything from hitting marks and working with close-ups to maintaining consistency across takes and collaborating with directors and crew.',
		publication_date: '1990',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Acting_in_Film.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'acting',
			'film',
			'michael',
			'caine',
			'film acting',
			'camera technique',
			'close-up',
			'hitting marks',
			'continuity',
			'film set',
			'actor preparation',
			'screen performance',
			'film crew',
			'directing actors',
			'rehearsal',
			'take',
			'performance',
			'subtlety',
			'film industry',
			'movie making',
			'acting tips',
			'professional acting',
		],
	},
	{
		title: 'The Business of Film',
		authors: ['Lawrence Turman', 'Stephen Fell'],
		abstract:
			'A comprehensive guide to the business and financial aspects of the film industry, covering the entire lifecycle of a film project from development and financing to distribution and marketing. This book provides practical insights into producing, deal-making, contracts, and the economic realities of getting films made and seen by audiences.',
		publication_date: '2019',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/The_business_of_film.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'business',
			'film',
			'lawrence',
			'turman',
			'stephen',
			'fell',
			'film business',
			'film financing',
			'film distribution',
			'producing',
			'deal-making',
			'film contracts',
			'entertainment law',
			'film marketing',
			'box office',
			'film economics',
			'production financing',
			'distribution deals',
			'film sales',
			'rights management',
			'film industry',
			'movie business',
			'financial planning',
			'revenue streams',
			'film investment',
		],
	},
	{
		title: 'Producer to Producer',
		authors: ['Maureen A. Ryan'],
		abstract:
			'A comprehensive step-by-step guide to independent film producing that takes filmmakers through the entire production process from concept to distribution. The book provides practical tools, templates, and real-world advice on budgeting, scheduling, fundraising, crew management, and navigating the business aspects of independent filmmaking.',
		publication_date: '2017',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Producer_to_Producer.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'producer',
			'producer',
			'maureen',
			'ryan',
			'film producing',
			'independent film',
			'film budgeting',
			'production scheduling',
			'fundraising',
			'film financing',
			'crowdfunding',
			'production management',
			'film business',
			'independent producing',
			'film distribution',
			'production templates',
			'crew management',
			'film contracts',
			'pre-production',
			'post-production',
			'film festival',
			'low-budget filmmaking',
			'production forms',
		],
	},
	{
		title: 'So You Want to Be a Producer',
		authors: ['Lawrence Turman'],
		abstract:
			'A practical guide to film producing from veteran producer Lawrence Turman, offering insider knowledge and career advice for aspiring producers. The book covers the creative, business, and leadership aspects of producing, including project selection, talent management, financing strategies, and the day-to-day realities of shepherding a film from idea to screen.',
		publication_date: '2005',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/So_You_Want_to_Be_a_Producer.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'you',
			'want',
			'to be',
			'producer',
			'lawrence',
			'turman',
			'film producing',
			'producer',
			'career guide',
			'film career',
			'project development',
			'talent management',
			'film financing',
			'creative producing',
			'leadership',
			'film industry',
			'movie business',
			'producer role',
			'career advice',
			'entertainment industry',
			'film development',
			'packageing',
			'deal making',
			'hollywood',
		],
	},
	{
		title: 'Directing the Documentary',
		authors: ['Michael Rabiger'],
		abstract:
			'Directing the Documentary is a definitive guide to the documentary form, helping filmmakers master the craft of documentary filmmaking. It covers the process from concept development to preproduction, production, and postproduction, offering practical lessons for transforming an idea into a complete documentary project.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/59.DIRECTING+THE+DOCUMENTARY+MICHAEL+RABIGER+AND+COURTNEY+HERMANN_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'directing',
			'documentary',
			'michael',
			'rabiger',
			'film making',
			'documentary filmmaking',
			'filmmaking process',
			'preproduction',
			'production',
			'postproduction',
			'documentary form',
			'concept development',
			'film craft',
			'nonfiction film',
			'director',
			'visual storytelling',
			'film production',
			'documentary production',
			'cinema',
			'filmmaker',
		],
	},
	{
		title:
			'Film Production Management 101: Production Management and Coordination in an Era of The Respectful Workplace and Sustainable Practices',
		authors: ['Deborah S. Patz'],
		abstract:
			'A comprehensive guide for film production professionals, designed to support growth from Production Coordinator to Production Manager and from low-budget to large-scale productions. The book provides practical guidance for hiring, crew coordination, preparation, postproduction, audits, respectful workplaces, and sustainable production practices.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/60.FILM+PRODUCTION+MANAGEMENT+101+DEBORAH+PATZ_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'film production',
			'production management',
			'production coordination',
			'deborah',
			'patz',
			'film making',
			'production manager',
			'production coordinator',
			'crew management',
			'hiring crew',
			'film prep',
			'postproduction',
			'audit',
			'sustainable practices',
			'respectful workplace',
			'low budget',
			'big budget',
			'film industry',
			'production process',
			'filmmaking',
		],
	},
	{
		title:
			"The Filmmaker's Eye: Learning (and Breaking) the Rules of Cinematic Composition",
		authors: ['Gustavo Mercado'],
		abstract:
			'The Filmmaker’s Eye teaches the rules and creative possibilities of cinematic composition. Through an analytical, technical, and aesthetic approach, Gustavo Mercado explains how filmmakers can create visually polished and narratively meaningful images by understanding the grammar of the shot.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/61.+THE+FILMMAKERS+EYE+GUSTAVO+MERCADO-OCR.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'filmmaker',
			'eye',
			'gustavo',
			'mercado',
			'cinematic composition',
			'composition',
			'visual grammar',
			'shot design',
			'cinematography',
			'film making',
			'visual storytelling',
			'image composition',
			'framing',
			'aesthetic analysis',
			'technical skills',
			'narrative images',
			'film language',
			'camera',
			'cinema',
			'filmmaking',
		],
	},
	{
		title: 'The Business of Film',
		authors: ['Stephen Greenwald', 'Paula Landry'],
		abstract:
			'The Business of Film introduces the business side of the filmmaking lifecycle, including planning, production, financing, marketing, and distribution. Stephen Greenwald and Paula Landry provide a practical guide to modern film business models, streaming, development, global distribution, exhibition, accounting, virtual production, and emerging media trends.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/62.THE+BUSINESS+OF+FILM+STEPHEN+R+GREENWALD+AND+PAULA+LANDRY_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'business',
			'film',
			'stephen',
			'greenwald',
			'paula',
			'landry',
			'film business',
			'film financing',
			'film marketing',
			'film distribution',
			'production planning',
			'streaming',
			'development',
			'exhibition',
			'virtual production',
			'film accounting',
			'business models',
			'media industry',
			'global distribution',
			'film making',
		],
	},
	{
		title:
			'Color Correction Look Book: Creative Grading Techniques for Film and Video',
		authors: ['Alexis Van Hurkman'],
		abstract:
			'Color Correction Look Book explores creative grading techniques for film and video. Alexis Van Hurkman explains how digital colorists go beyond balancing and fixing images to create stylized looks, recreate older recording aesthetics, and develop distinctive visual treatments in modern digital postproduction workflows.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/63.COLOR+CORRECTION+LOOK+BOOK+CREATIVE+GRADING+TECHNIQUES+FOR+FILM+AND+VIDEO_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'color correction',
			'look book',
			'creative grading',
			'alexis',
			'van hurkman',
			'film',
			'video',
			'color grading',
			'digital colorist',
			'postproduction',
			'visual style',
			'stylization',
			'film lab',
			'digital workflow',
			'image balance',
			'colorist',
			'grading suite',
			'film making',
			'cinematic look',
			'video production',
		],
	},
	{
		title:
			'Directing Actors: Creating Memorable Performances for Film & Television',
		authors: ['Judith Weston'],
		abstract:
			'Directing Actors explores how directors can help actors create memorable performances for film and television. Judith Weston explains what makes a strong performance, what actors need from directors, common directing mistakes, script analysis, preparation, actor process, and the director-actor relationship.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/64.DIRECTING+ACTORS+BY+JUDITH+WESTON+-+PORTADA_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'directing actors',
			'judith',
			'weston',
			'actor',
			'acting',
			'directing',
			'performance',
			'film',
			'television',
			'director',
			'script analysis',
			'actor process',
			'director actor relationship',
			'preparation',
			'memorable performances',
			'film making',
			'performance direction',
			'character',
			'theatre',
			'cinema',
		],
	},
	{
		title: 'Scheduling and Budgeting Your Film (American Film Market Presents)',
		authors: ['Paula Landry'],
		abstract:
			'Scheduling and Budgeting Your Film teaches the fundamentals of line producing, scheduling, and budgeting for film projects. Paula Landry provides practical tools, examples, and strategies for organizing resources, estimating costs, identifying hidden expenses, setting priorities, finding incentives, and managing production workflows.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/65.SCHEDULING+AND+BUDGETING+YOUR+FILM+PAULA+LANDRY_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'scheduling',
			'budgeting',
			'film',
			'paula',
			'landry',
			'line producing',
			'production budget',
			'film schedule',
			'resources',
			'distribution expenses',
			'hidden costs',
			'tax incentives',
			'production workflow',
			'film planning',
			'budget software',
			'film making',
			'production management',
			'cost estimation',
			'american film market',
			'producer',
		],
	},
	{
		title: 'Cutting Rhythms: Creative Film Editing',
		authors: ['Karen Pearlman'],
		abstract:
			'Cutting Rhythms examines the creative decision-making behind film editing, focusing on rhythm, timing, and the editor’s artistic process. Karen Pearlman offers principles and examples that help editors, filmmakers, and students understand how rhythm shapes audience engagement and cinematic meaning.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/66.+CUTTING+RHYTHMS+CREATIVE+FILM+EDITING+KAREN+PEARLMAN_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'cutting rhythms',
			'creative editing',
			'film editing',
			'karen',
			'pearlman',
			'editor',
			'editing rhythm',
			'rhythm',
			'timing',
			'creative process',
			'audience engagement',
			'filmmaking',
			'film making',
			'cinematic rhythm',
			'postproduction',
			'editorial decisions',
			'international films',
			'film craft',
			'narrative editing',
			'visual storytelling',
		],
	},
	{
		title:
			'Producer to Producer - 3rd Edition: A Step-by-Step Guide to Low Budget Independent Film Producing',
		authors: ['Maureen A. Ryan'],
		abstract:
			'Producer to Producer is a practical step-by-step guide for low-budget independent film producing. Maureen A. Ryan outlines the producing process in detail, including production meetings, checklists, preproduction, principal photography, postproduction, and delivery for emerging and professional producers.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/67.PRODUCER+TO+PRODUCER+MAUREEN+A+RYAN_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'producer',
			'producer to producer',
			'maureen',
			'ryan',
			'independent film',
			'low budget',
			'film producing',
			'production meetings',
			'checklists',
			'preproduction',
			'principal photography',
			'postproduction',
			'delivery',
			'film making',
			'indie film',
			'film production',
			'producing process',
			'emerging producers',
			'professional producers',
			'filmmaking',
		],
	},
	{
		title:
			'Cinematography: Theory and Practice: For Cinematographers and Directors',
		authors: ['Blain Brown'],
		abstract:
			'Cinematography: Theory and Practice covers the artistry, craftsmanship, tools, and technology of cinematography and visual storytelling. Blain Brown provides a roadmap for cinematographers and directors who want to deepen their mastery of cinematic techniques, visual design, and the evolving role of cinematography in filmmaking.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/68.CINEMATOGRAPHY+THEORY+AND+PRACTICE+FOR+CINEMATOGRAPHERS+AND+DIRECTORS+BLAIN+BROWN_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'cinematography',
			'theory',
			'practice',
			'blain',
			'brown',
			'cinematographer',
			'director',
			'visual storytelling',
			'film making',
			'cinematic techniques',
			'camera',
			'lighting',
			'visual design',
			'film craft',
			'tools',
			'technology',
			'cinema',
			'filmmaking',
			'image making',
			'visual language',
		],
	},
	{
		title:
			"The Independent Filmmaker's Guide to Writing a Business Plan for Investors",
		authors: ['Gabriel Campisi'],
		abstract:
			'The Independent Filmmaker’s Guide to Writing a Business Plan for Investors helps filmmakers prepare persuasive business plans to attract production capital. Gabriel Campisi explains how to approach potential investors, identify financial sources, avoid unscrupulous financiers, and structure a professional plan for independent film projects.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/69.+THE+INDEPENDET+FILMMAKERS+GUIDE+TO+WRITING+A+BUSINESS+PLAN+FOR+INVESTORS_ocr.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'independent filmmaker',
			'business plan',
			'investors',
			'gabriel',
			'campisi',
			'film financing',
			'production capital',
			'investment',
			'film business',
			'financial sources',
			'hollywood',
			'independent film',
			'producer',
			'fundraising',
			'film making',
			'business planning',
			'film investors',
			'financiers',
			'film projects',
			'production funding',
		],
	},
];

const data_LAURELI = [
	{
		title: 'Application of Plant-Based Molecules and Materials in Cosmetics',
		authors: ['Paulraj Mosae Mosae Selvakumar'],
		abstract:
			'With the growing demand for products that are gentle on the skin and manufactured by eco-friendly means, the field of cosmetics is witnessing a remarkable shift toward natural ingredients',
		publication_date: '2024',
		url: 'https://www.mdpi.com/2079-9284/11/6/211',
		type: '',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Application',
			'Plant-Based',
			'Molecules',
			'Materials',
			'Cosmetics',
			'Paulraj',
			'Mosae',
			'Selvakumar',
			'growing',
			'demand',
			'natural',
			'ingredients',
			'eco-friendly',
			'skin',
			'cosmetic-products',
			'plant-derived',
			'bioactive-compounds',
			'sustainability',
			'green-chemistry',
			'formulations',
			'botanical-extracts',
			'phytochemicals',
			'beauty-products',
			'personal-care',
			'natural-cosmetics',
			'clean-beauty',
			'biomaterials',
			'skin-care',
			'environmentally-friendly',
		],
	},
	{
		title: 'BAM Chapter 23: Methods for Cosmetics',
		authors: [
			'Jo Huang, Anthony D. Hitchins ',
			'Tony T. Tran',
			'James E. McCarron',
		],
		abstract:
			"FDA's Bacteriological Analytical Manual (BAM) presents the agency's preferred laboratory procedures for microbiological analyses of foods and cosmetics.",
		publication_date: '2025',
		url: 'https://www.fda.gov/food/laboratory-methods-food/bam-chapter-23-methods-cosmetics',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'BAM',
			'Chapter',
			'Methods',
			'Cosmetics',
			'Jo',
			'Huang',
			'Anthony',
			'Hitchins',
			'Tony',
			'Tran',
			'James',
			'McCarron',
			'FDA',
			'Bacteriological',
			'Analytical',
			'Manual',
			'laboratory',
			'procedures',
			'microbiological',
			'analyses',
			'foods',
			'cosmetics-testing',
			'microbiology',
			'laboratory-methods',
			'regulatory',
			'quality-control',
			'safety-testing',
			'contamination',
			'microbial-analysis',
			'standard-procedures',
			'food-safety',
			'cosmetic-safety',
		],
	},
	{
		title: 'Barbering Techniques for Hairstylists',
		authors: ['Arden Magtiza and Gary Franceschini'],
		abstract:
			'This manual serves as a guide for apprentices who desire to grow beyond their foundational haircutting knowledge and skills, and expand their knowledge to include more advanced barbering services, such as beard and moustache design, and straight razor shaves.',
		publication_date: '2021',
		url: 'https://collection.bccampus.ca/textbook/cte79aLm/',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Barbering',
			'Techniques',
			'Hairstylists',
			'Arden',
			'Magtiza',
			'Gary',
			'Franceschini',
			'manual',
			'apprentices',
			'haircutting',
			'skills',
			'advanced',
			'barbering-services',
			'beard-design',
			'moustache-design',
			'razor-shaves',
			'grooming',
			'hair-design',
			'barber-tools',
			'styling',
		],
	},
	{
		title: 'Cosmetics Labeling Guide',
		authors: ['Office of the Commissioner'],
		abstract:
			'The Cosmetics Labeling Guide provides step-by-step help with cosmetic labeling, with examples and answers to questions  manufacturers often ask about labeling requirements under U.S. laws and related regulations.',
		publication_date: '2021',
		url: 'https://www.fda.gov/cosmetics/cosmetics-labeling-regulations/cosmetics-labeling-guide',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Cosmetics',
			'Labeling',
			'Guide',
			'Office',
			'Commissioner',
			'FDA',
			'labeling-requirements',
			'regulations',
			'U.S.-laws',
			'cosmetic-products',
			'manufacturers',
			'compliance',
			'packaging',
			'claims',
			'ingredient-listing',
			'labeling-rules',
			'guidelines',
			'examples',
			'instructions',
			'regulatory',
		],
	},
	{
		title: 'Evidence-Based Massage Therapy: A Guide for Clinical Practice',
		authors: ['Richard Lebert'],
		abstract:
			'This clinical practice handbook will prove essential to massage therapists, physical therapists, chiropractors, medical doctors, psychologists and other health professionals who care for people with musculoskeletal pain. It is a living document and will be continuously updated as new research becomes available.',
		publication_date: '2018',
		url: 'https://collection.bccampus.ca/textbook/7WiDhceU/',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Evidence-Based',
			'Massage',
			'Therapy',
			'Clinical',
			'Practice',
			'Richard',
			'Lebert',
			'handbook',
			'therapists',
			'physical-therapy',
			'chiropractic',
			'health-professionals',
			'musculoskeletal-pain',
			'treatment',
			'manual-therapy',
			'rehabilitation',
			'pain-management',
			'clinical-guidelines',
			'research',
			'healthcare',
		],
	},
	{
		title: 'Hair Colour for Hairstylists: Level 2',
		authors: ['Arden Magtiza'],
		abstract:
			'This manual serves as a guide for apprentices with the desire to stretch beyond their foundational colour knowledge and skills so as to reach a higher level of competency. This text will walk the stylist step-by-step through many current and advanced techniques used in the industry today.',
		publication_date: '2021',
		url: 'https://collection.bccampus.ca/textbooks/hair-colour-for-hairstylists-level-2-bccampus-147/',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Hair',
			'Colour',
			'Hairstylists',
			'Level-2',
			'Arden',
			'Magtiza',
			'manual',
			'apprentices',
			'colour-knowledge',
			'skills',
			'competency',
			'stylist',
			'techniques',
			'advanced',
			'industry',
			'hair-colouring',
			'formulation',
			'application',
			'professional',
			'training',
		],
	},
	{
		title: 'Introductory Chemistry - 1st Canadian Edition',
		authors: ['Jessie A. Key', 'David W. Ball'],
		abstract:
			'The goal of this textbook is not to make you an expert. True expertise in any field is a years-long endeavor. Here I will survey some of the basic topics of chemistry. This survey should give you enough knowledge to appreciate the impact of chemistry in everyday life and, if necessary, prepare you for additional instruction in chemistry.Throughout each chapter, I present two features that reinforce the theme of the textbook.',
		publication_date: '2014',
		url: 'https://collection.bccampus.ca/textbook/8zgWk4FT/',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Introductory',
			'Chemistry',
			'Canadian',
			'Edition',
			'Jessie',
			'Key',
			'David',
			'Ball',
			'textbook',
			'basic-topics',
			'chemical-principles',
			'everyday-life',
			'foundations',
			'survey',
			'instruction',
			'chapters',
			'science',
			'learning',
			'education',
			'fundamentals',
		],
	},
	{
		title:
			'The Case for Pain Relief: 5 Research Studies for Massage Therapists',
		authors: ['Massage Theraphy Foundation'],
		abstract:
			"Likely highlights massage's benefits, showing it reduces pain, anxiety, depression, and improves strength in conditions like low back pain, cancer pain, and carpal tunnel, using evidence from studies by Field and others, indicating even short sessions with moderate pressure yield significant results, though high-certainty evidence for superiority over other active treatments is often lacking, necessitating more rigorous trials. ",
		publication_date: '2012',
		url: 'https://massagetherapyfoundation.org/wp-content/uploads/mtf-pain-relief-ebook.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Pain',
			'Relief',
			'Massage',
			'Therapists',
			'Massage-Therapy-Foundation',
			'research',
			'studies',
			'pain-reduction',
			'anxiety',
			'depression',
			'strength',
			'low-back-pain',
			'cancer-pain',
			'carpal-tunnel',
			'moderate-pressure',
			'treatment-effects',
			'evidence',
			'clinical',
			'outcomes',
			'therapeutic-benefits',
		],
	},
	{
		title:
			'5 Myths and Truths about Massage Therapy: Letting Go Without Losing Heart',
		authors: ['Massage Theraphy Foundation'],
		abstract:
			"Likely details common misconceptions (like massage detoxifies or is always painful) versus realities (it promotes well-being, enhances immune function, improves circulation locally, and addresses chronic pain patterns). The core idea is debunking myths to focus on proven benefits like stress reduction, pain relief, increased mobility, and supporting the body's healing, emphasizing the need for honest, evidence-based communication in the massage field. ",
		publication_date: '2016',
		url: 'https://www.tracywalton.com/wp-content/uploads/2016/09/5-Myths-and-Truths-about-Massage-Therapy_final-with-Page-Numers.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Myths',
			'Truths',
			'Massage',
			'Therapy',
			'Massage-Therapy-Foundation',
			'misconceptions',
			'evidence-based',
			'well-being',
			'immune-function',
			'circulation',
			'chronic-pain',
			'stress-reduction',
			'pain-relief',
			'mobility',
			'healing',
			'benefits',
			'education',
			'communication',
			'health',
			'therapeutic',
		],
	},
];

const booksDUARTE = [
	{
		title: 'Theory and Practice of Counseling and Psychotherapy',
		authors: ['Gerald Corey'],
		abstract:
			'Theory and Practice of Counseling and Psychotherapy explores the major theories and techniques used in counseling and psychotherapy, combining foundational concepts with practical applications for clinical practice. The book presents an integrative overview of different therapeutic approaches — including psychodynamic, cognitive-behavioral, existential, person-centered, and family systems therapies — while emphasizing the importance of the therapeutic relationship, ethical practice, and cultural sensitivity. Widely used in counselor education programs, it helps students and practitioners connect theory with real-world counseling situations through case examples and reflective exercises.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/70.THEORY+AND+PRACTICE+OF+COUNSELING+AND+PSYCHOTHERAPY.pdf',
		type: 'BOOK',
		resource_origin: 'Theory and Practice of Counseling and Psychotherapy',
		peer_reviewed: false,
		words: [
			'Theory and Practice of Counseling and Psychotherapy',
			'Gerald Corey',
			'Counseling',
			'Counselling',
			'Psychotherapy',
			'Counseling theories',
			'Counselling theories',
			'Psychotherapeutic techniques',
			'Therapeutic approaches',
			'Therapy models',
			'Mental health counseling',
			'Clinical counseling',
			'Clinical practice',
			'Ethical practice',
			'Counseling ethics',
			'Cultural sensitivity',
			'Therapeutic relationship',
			'Client therapist relationship',
			'Psychodynamic therapy',
			'Cognitive behavioral therapy',
			'CBT',
			'Existential therapy',
			'Person centered therapy',
			'Family systems therapy',
			'Integrative therapy',
			'Case studies',
			'Reflective exercises',
			'Counselor education',
			'Mental health',
			'Psychology',
			'Clinical psychology',
			'Behavioral health',
		],
	},
	{
		title:
			'Textbook of Psychiatry for Intellectual Disability and Autism Spectrum Disorder',
		authors: ['Marco O. Bertelli', 'Kerim Munir', 'Luis Salvador-Carulla'],
		abstract:
			'This comprehensive textbook examines the psychiatric assessment, diagnosis, and treatment of individuals with intellectual disability and autism spectrum disorder across the lifespan. It addresses clinical, behavioral, developmental, and social aspects of care, while highlighting evidence-based interventions, multidisciplinary approaches, and ethical considerations in mental health services for neurodiverse populations.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/71.TEXTBOOK+OF+PSYCHIATRY+FOR+INTELLECTUAL+DISABILITY+AND+AUTISM+SPECTRUM+DISORDER.pdf',
		type: 'BOOK',
		resource_origin:
			'Textbook of Psychiatry for Intellectual Disability and Autism Spectrum Disorder',
		peer_reviewed: false,
		words: [
			'Textbook of Psychiatry for Intellectual Disability and Autism Spectrum Disorder',
			'Marco O. Bertelli',
			'Kerim Munir',
			'Luis Salvador-Carulla',
			'Psychiatry',
			'Psychiatric assessment',
			'Psychiatric diagnosis',
			'Psychiatric treatment',
			'Intellectual disability',
			'Autism spectrum disorder',
			'ASD',
			'Autism',
			'Neurodevelopmental disorders',
			'Developmental disability',
			'Neurodiversity',
			'Neurodiverse populations',
			'Mental health',
			'Mental health services',
			'Clinical psychiatry',
			'Behavioral assessment',
			'Behavioral care',
			'Developmental care',
			'Social aspects of care',
			'Lifespan development',
			'Evidence based interventions',
			'Multidisciplinary care',
			'Ethical considerations',
			'Clinical interventions',
			'Disability studies',
			'Special needs',
			'Psychological disorders',
			'Autism treatment',
			'Autism diagnosis',
		],
	},
	{
		title: 'Textbook of Autism Spectrum Disorders',
		authors: ['Eric Hollander', 'Randi J. Hagerman', 'Casara Jean Ferretti'],
		abstract:
			'This textbook provides an in-depth overview of autism spectrum disorders, covering current research, diagnostic criteria, developmental characteristics, neurobiology, and evidence-based interventions. It explores the educational, behavioral, psychological, and social dimensions of autism across different stages of life, offering practical guidance for clinicians, educators, researchers, and caregivers.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/72.TEXT+BOOK+OF+AUTISM+SPECTRUM+DISORDERS.pdf',
		type: 'BOOK',
		resource_origin: 'Textbook of Autism Spectrum Disorders',
		peer_reviewed: false,
		words: [
			'Textbook of Autism Spectrum Disorders',
			'Eric Hollander',
			'Randi J. Hagerman',
			'Casara Jean Ferretti',
			'Autism spectrum disorders',
			'Autism spectrum disorder',
			'ASD',
			'Autism',
			'Neurodevelopmental disorders',
			'Developmental psychology',
			'Child psychology',
			'Behavioral psychology',
			'Educational psychology',
			'Clinical psychology',
			'Psychology',
			'Diagnostic criteria',
			'Autism diagnosis',
			'Autism research',
			'Current research',
			'Neurobiology',
			'Developmental characteristics',
			'Evidence based interventions',
			'Behavioral interventions',
			'Educational interventions',
			'Psychological interventions',
			'Social development',
			'Social behavior',
			'Caregiver guidance',
			'Clinician guidance',
			'Educator resources',
			'Researchers',
			'Autism treatment',
			'Special education',
			'Neurodiversity',
		],
	},
	{
		title: 'Simply Psychology',
		authors: ['Michael W. Eysenck'],
		abstract:
			'This accessible introduction to psychology presents key psychological concepts, theories, and research in a clear and engaging format. The book covers major areas such as cognition, behavior, emotions, personality, mental health, and human development, making complex topics understandable for students and general readers alike.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/73.SIMPLY+PSYCHOLOGY+MICHAEL+W+EYSENCK.pdf',
		type: 'BOOK',
		resource_origin: 'Simply Psychology',
		peer_reviewed: false,
		words: [
			'Simply Psychology',
			'Michael W. Eysenck',
			'Psychology',
			'Introduction to psychology',
			'Introductory psychology',
			'General psychology',
			'Basic psychology',
			'Psychological concepts',
			'Psychological theories',
			'Psychological research',
			'Human behavior',
			'Behavior',
			'Cognition',
			'Cognitive psychology',
			'Emotions',
			'Emotion psychology',
			'Personality',
			'Personality psychology',
			'Mental health',
			'Human development',
			'Developmental psychology',
			'Student psychology',
			'Psychology textbook',
			'Psychology basics',
			'Learning psychology',
			'Behavioral science',
			'Mind and behavior',
			'Social behavior',
			'Clinical psychology',
		],
	},
	{
		title: 'Psychology 2e',
		authors: ['Rose M. Spielman', 'Marilyn D. Lovett', 'William J. Jenkins'],
		abstract:
			'This introductory textbook provides a broad overview of the scientific study of psychology, covering topics such as biological foundations of behavior, learning, memory, cognition, development, personality, social psychology, and psychological disorders. Written in an accessible style, it combines foundational theory with real-world applications and current research to support student learning.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/74.PSYCHOLOGY+2E.pdf',
		type: 'BOOK',
		resource_origin: 'Psychology 2e',
		peer_reviewed: false,
		words: [
			'Psychology 2e',
			'Rose M. Spielman',
			'Marilyn D. Lovett',
			'William J. Jenkins',
			'Psychology',
			'General psychology',
			'Introduction to psychology',
			'Introductory psychology',
			'Scientific study of psychology',
			'Psychological research methods',
			'Research methods',
			'Biological foundations of behavior',
			'Biopsychology',
			'Behavior',
			'Human behavior',
			'Learning',
			'Memory',
			'Cognition',
			'Cognitive psychology',
			'Human development',
			'Developmental psychology',
			'Personality',
			'Personality psychology',
			'Social psychology',
			'Psychological disorders',
			'Mental disorders',
			'Mental health',
			'Behavioral processes',
			'Cognitive processes',
			'Foundational theory',
			'Real world applications',
			'Student learning',
			'Psychology textbook',
			'OpenStax psychology',
		],
	},
	{
		title: 'Evolutionary Psychology: The New Science of the Mind',
		authors: ['David M. Buss'],
		abstract:
			'This influential textbook explores human behavior and cognition through the lens of evolutionary theory. It examines how natural and sexual selection have shaped psychological traits related to survival, mating, emotions, social behavior, aggression, and decision-making. The book integrates research from psychology, biology, and anthropology to explain the evolutionary foundations of the human mind.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/75.EVOLUTION+PSYCHOLOGY+DAVID+M+BUSS.pdf',
		type: 'BOOK',
		resource_origin: 'Evolutionary Psychology: The New Science of the Mind',
		peer_reviewed: false,
		words: [
			'Evolutionary Psychology: The New Science of the Mind',
			'David M. Buss',
			'Evolutionary psychology',
			'Evolution psychology',
			'Psychology',
			'Human behavior',
			'Human cognition',
			'Cognitive evolution',
			'Social evolution',
			'Evolutionary theory',
			'Natural selection',
			'Sexual selection',
			'Survival',
			'Mating behavior',
			'Mating psychology',
			'Emotions',
			'Aggression',
			'Decision making',
			'Social behavior',
			'Human adaptation',
			'Adaptive behavior',
			'Mind and behavior',
			'Biology',
			'Anthropology',
			'Biological psychology',
			'Behavioral science',
			'Evolution of the mind',
			'Human nature',
			'Cognitive science',
			'Comparative psychology',
			'Social psychology',
		],
	},
	{
		title: 'An Introduction to Counselling and Psychotherapy',
		authors: ['Andrew Reeves'],
		abstract:
			'This introductory text presents the fundamental theories, approaches, and practices of counselling and psychotherapy. It explores major therapeutic models — including psychodynamic, cognitive-behavioral, humanistic, and integrative approaches — while examining the role of the therapist, the therapeutic relationship, and ethical considerations in mental health practice. The book is designed to help students and beginning practitioners understand both the theoretical foundations and practical application of psychotherapy.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/76.COUNSELLING+%26+PSYCHOTHERAPY+FROM+THEORY+TO+PRACTICE.pdf',
		type: 'BOOK',
		resource_origin: 'An Introduction to Counselling and Psychotherapy',
		peer_reviewed: false,
		words: [
			'An Introduction to Counselling and Psychotherapy',
			'Andrew Reeves',
			'Counselling',
			'Counseling',
			'Psychotherapy',
			'Introduction to counselling',
			'Introduction to counseling',
			'Counselling and psychotherapy',
			'Counseling and psychotherapy',
			'Therapeutic approaches',
			'Therapeutic models',
			'Therapy models',
			'Mental health practice',
			'Mental health counseling',
			'Psychodynamic therapy',
			'Cognitive behavioral therapy',
			'CBT',
			'Humanistic therapy',
			'Integrative therapy',
			'Therapist role',
			'Therapeutic relationship',
			'Client therapist relationship',
			'Ethical considerations',
			'Counseling ethics',
			'Psychotherapy practice',
			'Clinical practice',
			'Beginning practitioners',
			'Counselor training',
			'Counsellor training',
			'Psychology',
			'Clinical psychology',
			'Behavioral health',
		],
	},
	{
		title: 'An Introduction to Counselling and Psychotherapy',
		authors: ['Andrew Reeves'],
		abstract:
			'This introductory text presents the fundamental theories, approaches, and practices of counselling and psychotherapy. It explores major therapeutic models — including psychodynamic, cognitive-behavioral, humanistic, and integrative approaches — while examining the role of the therapist, the therapeutic relationship, and ethical considerations in mental health practice. The book is designed to help students and beginning practitioners understand both the theoretical foundations and practical application of psychotherapy.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/76.COUNSELLING+%26+PSYCHOTHERAPY+FROM+THEORY+TO+PRACTICE.pdf',
		type: 'BOOK',
		resource_origin: 'An Introduction to Counselling and Psychotherapy',
		peer_reviewed: false,
		words: [
			'An Introduction to Counselling and Psychotherapy',
			'Andrew Reeves',
			'Counselling',
			'Counseling',
			'Psychotherapy',
			'Introduction to counselling',
			'Introduction to counseling',
			'Counselling and psychotherapy',
			'Counseling and psychotherapy',
			'Therapeutic approaches',
			'Therapeutic models',
			'Therapy models',
			'Mental health practice',
			'Mental health counseling',
			'Psychodynamic therapy',
			'Cognitive behavioral therapy',
			'CBT',
			'Humanistic therapy',
			'Integrative therapy',
			'Therapist role',
			'Therapeutic relationship',
			'Client therapist relationship',
			'Ethical considerations',
			'Counseling ethics',
			'Psychotherapy practice',
			'Clinical practice',
			'Beginning practitioners',
			'Counselor training',
			'Counsellor training',
			'Psychology',
			'Clinical psychology',
			'Behavioral health',
		],
	},
	{
		title: 'Autism Spectrum Disorders',
		authors: ['Jill Boucher'],
		abstract:
			'This book provides an overview of autism spectrum disorders, examining their characteristics, diagnosis, causes, and intervention strategies. It discusses developmental, behavioral, cognitive, and social aspects of autism, while presenting evidence-based approaches for assessment, education, therapy, and family support across the lifespan.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/AUTISM+SPECTRUM+DISORDERS+JILL+BOUCHER.pdf',
		type: 'BOOK',
		resource_origin: 'Autism Spectrum Disorders',
		peer_reviewed: false,
		words: [
			'Autism Spectrum Disorders',
			'Autism Spectrum Disorder',
			'Jill Boucher',
			'Autism',
			'ASD',
			'Developmental disorders',
			'Neurodevelopmental disorders',
			'Developmental psychology',
			'Behavioral intervention',
			'Behavioral support',
			'Autism intervention',
			'Autism support',
			'Autism diagnosis',
			'Autism characteristics',
			'Autism causes',
			'Autism assessment',
			'Evidence based approaches',
			'Evidence based intervention',
			'Autism education',
			'Special education',
			'Therapy for autism',
			'Family support',
			'Lifespan autism',
			'Cognitive development',
			'Social development',
			'Behavioral development',
			'Social aspects of autism',
			'Cognitive aspects of autism',
			'Clinical psychology',
			'Child psychology',
			'Mental health',
			'Neurodiversity',
		],
	},
	{
		title:
			'Psychoanalysis and Psychotherapy: Developments in Theory, Technique, and Training',
		authors: ['Franz Alexander'],
		abstract:
			'This books examines the evolution of psychoanalytic thought into more practical and adaptive forms of psychotherapy, emphasizes the shift from classical, long-term analysis toward more flexible, goal-oriented treatments that address patients’ immediate emotional needs. Central to his approach is the concept of the “corrective emotional experience,” where therapeutic interactions help reshape maladaptive patterns.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/EV-260-1782316860-6a3bff3c12311.pdf',
		type: 'BOOK',
		resource_origin:
			'Psychoanalysis and Psychotherapy: Developments in Theory, Technique, and Training',
		peer_reviewed: false,
		words: [
			'Psychoanalysis and Psychotherapy: Developments in Theory, Technique, and Training',
			'Franz Alexander',
			'Psychoanalysis',
			'Psychotherapy',
			'Cognitive Psychology',
			'Behavioral Intervention and Support',
			'Psychoanalytic theory',
			'Psychoanalytic thought',
			'Psychoanalytic technique',
			'Psychotherapy theory',
			'Psychotherapy technique',
			'Psychotherapy training',
			'Corrective emotional experience',
			'Emotional experience',
			'Emotional needs',
			'Maladaptive patterns',
			'Psychological change',
			'Therapeutic relationship',
			'Therapeutic interaction',
			'Goal oriented therapy',
			'Flexible psychotherapy',
			'Classical psychoanalysis',
			'Long term analysis',
			'Clinical psychology',
			'Mental health',
			'Psychodynamic therapy',
			'Psychodynamic psychotherapy',
			'Behavioral health',
			'Counseling',
			'Counselling',
			'Clinical practice',
		],
	},
];

const DENTISTRY_BOOKS = [
	{
		title: 'Modern Dental Assisting',
		authors: ['Doni Bird', 'Robinson Debbie'],
		abstract:
			'This book provide the background, principles, and techniques necessary to become an educationally qualified and competent dental assistant.',
		publication_date: '2015',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/Modern_dental_assistant_-_Debbie_S_Robinson.pdf',
		type: 'BOOK',
		resource_origin: '',
		peer_reviewed: false,
		words: [
			'Dentistry',
			'Health Education',
			'Medical personnel',
			'Modern dental',
			'modern dental assisting',
			'dentist',
			'dental',
		],
	},
];

const data_OMI = [
	{
		title: 'PALS - Pediatric Advanced Life Support Provider Manual',
		authors: ['American Heart Association'],
		abstract:
			'This book is a comprehensive clinical guide to support healthcare professionals in the management of critically ill infants and children. The book focuses on evidence-based strategies for recognizing and responding to pediatric emergencies, including respiratory distress, shock, and cardiac arrest. It emphasizes systematic assessment, effective teamwork, and high-quality cardiopulmonary resuscitation (CPR) tailored to pediatric patients.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/79.+Pediatric+Advanced+Life+Support+Provider+Manual.pdf',
		type: 'BOOK',
		resource_origin: '79. Pediatric Advanced Life Support Provider Manual.pdf',
		peer_reviewed: false,
		words: [
			'PALS',
			'Pediatric Advanced Life Support',
			'PALS Provider Manual',
			'PALS Manual',
			'American Heart Association',
			'AHA',
			'pediatric life support',
			'pediatric emergency',
			'child emergency',
			'infant emergency',
			'pediatric CPR',
			'pediatric resuscitation',
			'cardiac arrest',
			'respiratory distress',
			'pediatric shock',
			'advanced life support',
			'healthcare professionals',
			'pediatric critical care',
			'clinical guide',
			'provider manual',
		],
	},

	{
		title: 'ACLS - Advanced Cardiovascular Life Support Provider Manual',
		authors: ['American Heart Association'],
		abstract:
			'This book is a clinical resource for healthcare professionals managing adult cardiovascular emergencies. The manual emphasizes evidence-based approaches to the recognition and treatment of cardiac arrest, stroke, acute coronary syndromes, and other life-threatening conditions. It promotes the use of systematic assessment, high-quality CPR, and effective airway and pharmacologic interventions.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/80.+ACLS+Provider+Manual+eBook+(International+English).pdf',
		type: 'BOOK',
		resource_origin:
			'80. ACLS Provider Manual eBook (International English).pdf',
		peer_reviewed: false,
		words: [
			'ACLS',
			'Advanced Cardiovascular Life Support',
			'ACLS Provider Manual',
			'ACLS Manual',
			'American Heart Association',
			'AHA',
			'advanced life support',
			'adult emergency care',
			'cardiac arrest',
			'stroke',
			'acute coronary syndrome',
			'heart attack',
			'CPR',
			'airway management',
			'cardiovascular emergency',
			'emergency medicine',
			'pharmacologic interventions',
			'clinical guide',
			'provider manual',
			'resuscitation',
		],
	},

	{
		title: 'BLS - Basic Life Support Provider Manual',
		authors: ['American Heart Association'],
		abstract:
			'This book is an essential guide for providers and trained responders delivering immediate care in life-threatening emergencies. It focuses on foundational life-saving skills, including high-quality cardiopulmonary resuscitation (CPR), use of automated external defibrillators (AEDs), and relief of choking in adults, children, and infants. The manual emphasizes early recognition, rapid intervention, and coordinated team response to improve survival outcomes.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/81.+Basic+Life+Support+Provider+Manual.pdf',
		type: 'BOOK',
		resource_origin: '81. Basic Life Support Provider Manual.pdf',
		peer_reviewed: false,
		words: [
			'BLS',
			'Basic Life Support',
			'BLS Provider Manual',
			'BLS Manual',
			'American Heart Association',
			'AHA',
			'CPR',
			'cardiopulmonary resuscitation',
			'AED',
			'automated external defibrillator',
			'choking',
			'adult CPR',
			'child CPR',
			'infant CPR',
			'basic life support',
			'emergency response',
			'first aid',
			'life-saving skills',
			'clinical guide',
			'provider manual',
		],
	},

	{
		title: 'PHTLS - Prehospital Trauma Life Support Course Manual',
		authors: ['National Association of Emergency Medical Technicians'],
		abstract:
			'This book is a comprehensive guide that focuses on the rapid assessment and management of trauma patients in prehospital settings. It emphasizes a systematic approach to patient evaluation, prioritizing life-threatening conditions and critical interventions to improve survival outcomes. The book integrates evidence-based practices, including airway management, hemorrhage control, shock treatment, and rapid transport decisions. The text reinforces clinical decision-making and teamwork for emergency medical providers. Designed for paramedics, EMTs, and first responders, it serves as both a training resource and field reference for delivering effective trauma care in dynamic and high-risk environments.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/82.+PHTLS+PREHOSPITAL+TRAUMA+LIFE+SUPPORT+COURSE+MANUAL.pdf',
		type: 'BOOK',
		resource_origin:
			'82. PHTLS PREHOSPITAL TRAUMA LIFE SUPPORT COURSE MANUAL.pdf',
		peer_reviewed: false,
		words: [
			'PHTLS',
			'Prehospital Trauma Life Support',
			'PHTLS Course Manual',
			'PHTLS Manual',
			'NAEMT',
			'National Association of Emergency Medical Technicians',
			'prehospital care',
			'trauma care',
			'trauma patient',
			'EMT',
			'paramedic',
			'first responder',
			'bleeding control',
			'hemorrhage control',
			'airway management',
			'shock treatment',
			'trauma assessment',
			'emergency medical services',
			'clinical guide',
			'provider manual',
		],
	},

	{
		title: 'TECC - Tactical Emergency Casualty Care Course Manual',
		authors: ['National Association of Emergency Medical Technicians'],
		abstract:
			'This book is a practical guide designed for civilian first responders, law enforcement, and emergency medical personnel managing trauma in high-threat environments. Based on principles adapted from military medicine, the manual emphasizes rapid, evidence-based care under conditions such as active violence or disaster scenarios. It introduces a phased approach prioritizing scene safety, hemorrhage control, airway management, and rapid casualty extraction. The text highlights the use of tourniquets, wound packing, and situational awareness to reduce preventable deaths. Through clear guidelines, real-world applications, and structured algorithms, the manual supports effective decision-making and teamwork in dynamic, high-risk settings, aiming to improve survival outcomes in tactical and prehospital emergencies.',
		publication_date: '',
		url: 'https://institutions-assets.s3.us-east-2.amazonaws.com/books/83.+TECC+TACTICAL+EMERGENCY+CASUALTY+CARE+COURSE+MANUAL.pdf',
		type: 'BOOK',
		resource_origin:
			'83. TECC TACTICAL EMERGENCY CASUALTY CARE COURSE MANUAL.pdf',
		peer_reviewed: false,
		words: [
			'TECC',
			'Tactical Emergency Casualty Care',
			'TECC Course Manual',
			'TECC Manual',
			'NAEMT',
			'National Association of Emergency Medical Technicians',
			'tactical emergency care',
			'tactical medicine',
			'prehospital care',
			'trauma care',
			'active shooter',
			'law enforcement',
			'first responder',
			'hemorrhage control',
			'bleeding control',
			'tourniquet',
			'wound packing',
			'casualty care',
			'high threat environment',
			'clinical guide',
		],
	},
];
